import {
  CatalogQueryType,
  CatalogSearchResultData,
  CatalogSearchResultItem,
  ResourceCatalogDevice,
  ResourceCatalogDevicePaged,
} from './types';
import {
  DevHubGrid,
  DevHubIconButton,
  DevHubTooltip,
} from '@devxdiscover/devhub-ui';

import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

/**
 * DeviceResult returns device details for the search results
 * @param data row containing data for the device
 */
export const DeviceDetails = (data: CatalogSearchResultItem) => {
  const deviceData = data.item as ResourceCatalogDevice;
  return (
    <DevHubGrid container>
      <DevHubGrid item xs={1} />
      <DevHubGrid container item xs={11} spacing={0}>
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>Serial Number</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          <>
            {deviceData.serialNumber}
            <DevHubTooltip title="Copy">
              <DevHubIconButton
                size="small"
                onClick={() =>
                  navigator.clipboard.writeText(deviceData.serialNumber)
                }
              >
                <FileCopyOutlinedIcon fontSize="small" />
              </DevHubIconButton>
            </DevHubTooltip>
          </>
        </DevHubGrid>
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>Operating System</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          {deviceData.osInfo.edition}
        </DevHubGrid>
        {deviceData.environment && (
          <>
            <DevHubGrid item xs={2}>
              <span style={{ fontWeight: 'bold' }}>Environment</span>
            </DevHubGrid>
            <DevHubGrid item xs={10}>
              {deviceData.environment}
            </DevHubGrid>
          </>
        )}
        {deviceData.tier && (
          <>
            <DevHubGrid item xs={2}>
              <span style={{ fontWeight: 'bold' }}>Tier</span>
            </DevHubGrid>
            <DevHubGrid item xs={10}>
              {deviceData.tier}
            </DevHubGrid>
          </>
        )}
        <DevHubGrid item xs={2}>
          <span style={{ fontWeight: 'bold' }}>ID</span>
        </DevHubGrid>
        <DevHubGrid item xs={10}>
          {deviceData.deviceId}
        </DevHubGrid>
      </DevHubGrid>
    </DevHubGrid>
  );
};

/**
 * convertDeviceSearchResult converts the device search results into a format that can be displayed
 * @param deviceData the data returned from the fusion query
 */
export const convertDeviceSearchResult = (
  deviceData: ResourceCatalogDevicePaged,
): CatalogSearchResultData => {
  const deviceItems: CatalogSearchResultItem[] = (
    deviceData.resources.devicesPaged.devices as ResourceCatalogDevice[]
  ).map(item => ({
    expandable: true,
    name: item.fqdn,
    id: item.deviceId,
    ipAddress: item.ipAddress,
    os: item.osInfo.name,
    type: CatalogQueryType.Device,
    item: item,
  }));

  return {
    items: deviceItems,
    totalCount: deviceData.resources.devicesPaged.totalCount,
  };
};
